module.exports = {
    "source_code": "HLXEMS",
    "site_id": "info.thsu.edu",
    "title": "Texas Health and Science University",
    "tfn": "#",
    "url": "https://info.thsu.edu",
    "gtm_code": "GTM-MGK7C5B",
}